var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditinfocard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8018 3.28004C14.0943 2.98754 14.0943 2.50004 13.8018 2.22254L12.0468 0.467544C11.7693 0.175044 11.2818 0.175044 10.9893 0.467544L9.60929 1.84004L12.4218 4.65254M0.519287 10.9375V13.75H3.33179L11.6268 5.44754L8.81429 2.63504L0.519287 10.9375Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditinfocard);
export default __webpack_public_path__ + "static/media/editinfocard.a8c164fe260f11235b3222c40d0b43ab.svg";
export { ForwardRef as ReactComponent };